//
//
//
//
//
//
//
//
//
//

export default {
  name: 'check-in-show',
  props: {
    rooms: {
      type: Number,
      default: 1,
    },
    adults: {
      type: Number,
      default: 1,
    },
    children: {
      type: Number,
      default: 0,
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/CheckInShow/CheckInShow.vue